<template>
    <div class="card h-100 border-0 rounded-0 bg-white stats-box">
        <div class="card-body d-flex pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15">
            <div class="d-flex align-items-center">
                <div class="icon position-relative rounded-circle text-center flex-shrink-0 text-danger"><i
                        class="ph ph-user-plus"></i></div>
                <div class="title ms-15">
                    <h4 class="fw-black lh-1 m-0">
                        <router-link to="/create-patient" class="text-decoration-none text-fk-primary">
                            {{ $t('cta.create_patient') }}
                            <i class="ph-bold ph-plus position-relative ms-5 fs-12"></i>
                        </router-link>
                    </h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: "CreatePatientCard"
})
</script>